import { getCursorPosition } from "./getCursorPosition.js";
import { getCursorPositionInNode } from "./getCursorPositionInNode.js";
import { getListItems } from "./getListItems.js";
/**
 * Returns true when editor has collapsed selection and the cursor is at the beginning of a "list-item".
 */
export function isAtStartOfListItem(editor, schema) {
  let at = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : editor.selection;
  const point = getCursorPosition(editor, at);
  if (!point) {
    return false;
  }
  const listItemsInSelection = getListItems(editor, schema, point);
  if (listItemsInSelection.length !== 1) {
    return false;
  }
  const [[, listItemPath]] = listItemsInSelection;
  const {
    isStart
  } = getCursorPositionInNode(editor, point, listItemPath);
  return isStart;
}